"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.empresaGestionConverter = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
const empresaGestionConverter = {
    toFirestore(empresa) {
        const obj = empresa;
        obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({
            buscableParcialPor: [
                obj.nombreComercial,
                obj.rut,
                obj.razonSocial,
                obj.mailPrincipal,
                obj.mailRegistro,
                obj.accesoDGICedula,
                obj.contadorMail,
                obj.codigoPromocional,
                obj.codigoPromocionalIngresado
            ],
            buscableExactoPor: [obj.id]
        });
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            datosRegistroManagment: data.datosRegistroManagment ?? "",
            idViejaVersion: data.idViejaVersion ?? 0,
            version: data.version,
            mailRegistro: data.mailRegistro,
            mailPrincipal: data.mailPrincipal,
            nombreComercial: data.nombreComercial,
            rut: data.rut,
            razonSocial: data.razonSocial,
            domicilio: data.domicilio,
            localidad: data.localidad,
            departamento: data.departamento,
            celular: data.celular,
            tieneCedula: data.tieneCedula,
            cedula: data.cedula,
            documentoExtranjero: data.documentoExtranjero,
            fotoDocumentoExtranjero: data.fotoDocumentoExtranjero ?? "",
            constanciaLiteralE: data.constanciaLiteralE ?? "",
            primerNombre: data.primerNombre,
            segundoNombre: data.segundoNombre,
            primerApellido: data.primerApellido,
            segundoApellido: data.segundoApellido,
            tieneContador: data.tieneContador,
            contadorNombre: data.contadorNombre,
            contadorMail: data.contadorMail,
            contadorTelefono: data.contadorTelefono,
            fechaRegistro: data.fechaRegistro,
            buscableParcialPor: data.buscableParcialPor,
            buscableExactoPor: data.buscableExactoPor,
            registroHandy: data.registroHandy,
            vencimientoFirma: data.vencimientoFirma,
            plan: data.plan,
            planPersonalizadoDescripcion: data.planPersonalizadoDescripcion,
            planPersonalizadoImporte: data.planPersonalizadoImporte,
            sucursalesExtra: data.sucursalesExtra ?? 0,
            sucursalesExtraGratis: data.sucursalesExtraGratis ?? 0,
            cantidadComprobantesEmitidos: data.cantidadComprobantesEmitidos ?? 0,
            accesoDGICedula: data.accesoDGICedula,
            accesoDGIClave: data.accesoDGIClave,
            accesoDGIClaveEnviada: data.accesoDGIClaveEnviada,
            codigoPromocional: data.codigoPromocional ?? "",
            codigoPromocionalIngresado: data.codigoPromocionalIngresado ?? "",
            constanciaPostulacion: data.constanciaPostulacion,
            estado: data.estado,
            emisorElectronicoDesde: data.emisorElectronicoDesde,
            cobrarDesde: data.cobrarDesde,
            cobrarDesdeMesAno: data.cobrarDesdeMesAno ?? "",
            pagoAnual: data.pagoAnual,
            declaracionBeneficio: data.declaracionBeneficio,
            declaracionBeneficioHistorico: data.declaracionBeneficioHistorico,
            beneficioCalculado: data.beneficioCalculado ?? [],
            mailEnvioFactura: data.mailEnvioFactura,
            mailEnvioFirma: data.mailEnvioFirma,
            telefono: data.telefono,
            esLiteralE: data.esLiteralE,
            cantidadComprobantesAdicionales: data.cantidadComprobantesAdicionales ?? 0,
            cantidadComprobantesAdicionalesFechaTope: data.cantidadComprobantesAdicionalesFechaTope ?? 0,
            servicioSuspendido: data.servicioSuspendido ?? false,
            fechaBaja: data.fechaBaja ?? 0,
            historialBaja: data.historialBaja ?? 0,
            viaEntrada: data.viaEntrada ?? "",
            esCambioProveedor: data.esCambioProveedor ?? false,
            fechaMigrado: data.fechaMigrado,
            caeCargados: data.caeCargados ?? false,
            fechaUltimoEnvioSolicitudUsuarioDGI: data.fechaUltimoEnvioSolicitudUsuarioDGI ?? 0,
            fechaUltimoEnvioSolicitudFirmaAbitab: data.fechaUltimoEnvioSolicitudFirmaAbitab ?? 0,
            pendientePostular: data.pendientePostular ?? false,
            esAFU: data.esAFU ?? false,
            caeAlertaCPATU: data.caeAlertaCPATU ?? false,
            esCPATU: data.esCPATU ?? false,
            esCPATUTerminalesOCA: data.esCPATUTerminalesOCA ?? [],
            ultimoChequeo: data.ultimoChequeo ?? 0
        };
    }
};
exports.empresaGestionConverter = empresaGestionConverter;
